/* Conversion Dude: device filter for the PDP gallery (test theme).
   Images mapped to iPhone models (from iphone-case-alt-text-dry-run.csv, matched by file name) only show
   when one of those models is selected; images without a mapping show for every model.
   Once the alt texts are written to the store, this mapping can be replaced by reading the alt text. */
(function () {
  var MAP = {
"iphone_17_carousel_PDP_2": {
"model": "iPhone 17"
},
"iPhone_16_E": {
"model": "iPhone 16e"
},
"iPhone_17_PDPs": {
"model": "iPhone 17"
},
"iPhone_17_PDPs_5": {
"model": "iPhone 17"
},
"iPhone_17_PDPs_6": {
"model": "iPhone 17"
},
"iPhone_17_thumbnails_2": {
"model": "iPhone 17"
},
"iphone_17_carousel_PDP_1": {
"model": "iPhone 17"
},
"1_22ebcece-74c6-4fa3-bd86-f39e93e60d51": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"3_34e5b228-f335-44f2-852e-756bdb9858e3": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"4_37ba72ea-c04e-4d5e-87c6-5e95954e01e4": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"8_42e8c153-0bc7-43b5-9c8e-afac6fd63343": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"transparent_BG_thumbnails_19": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"5_f8034ecc-ab03-4de3-9f07-ce1861a9448c": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"2_c984f3cf-d7d4-4c69-a587-fd880c10df6d": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"6_cbac4497-3b84-47a9-a434-dd571e270e0c": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"transparent_BG_thumbnails_17": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"7_7aa76c23-69eb-4043-9d2e-63ae42f35370": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"107_4e6e33db-faf6-46db-b6b6-c34482e03d2d": {
"model": "iPhone 18"
},
"1_e496dc04-ba56-4049-81af-967d78792043": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"2_59c5c8b7-8666-4c8e-be30-3b8ce9b149db": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"3_b0e5d5db-e11d-437d-9868-c23609197852": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"4_8210fae8-75de-4906-b582-016dea3803c2": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"5_58a5b5d6-8ebd-448b-9530-278e40b2f167": {
"model": "iPhone 11 Pro Max"
},
"6_52841baf-d088-4954-9d14-90d6faafb8d9": {
"model": "iPhone 11 Pro Max"
},
"7_337e68b0-c45f-469b-9e9e-168b6c247036": {
"model": "iPhone 11 Pro"
},
"9_16e1cebb-5b7c-4392-aaff-4eb98aeeaf90": {
"model": "iPhone 11 Pro Max"
},
"10_7661d97b-90e3-4baf-9369-dc098316dd62": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"UC_-_transparent_BG_thumbnails": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"5_2582eddb-5207-4285-9819-ed75db351577": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"12_f92365e2-ccc0-41bb-8ed9-4fc5453e7eaf": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"106_885d7241-08bf-48fb-bcb1-ceaedd711d51": {
"model": "iPhone 18"
},
"1_4a998611-8090-40f5-9aa0-1e7da563955b": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"2_7b25671a-febb-4f43-bb56-28bcfade0519": {
"model": "iPhone 12 Pro"
},
"3_5293e585-0944-4c2a-8d30-8d22f62d6c27": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"4_4299837e-5a1d-46f1-b045-f48a7f8acbdb": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"5_fa35459f-8ae6-47e0-8225-188d1107f47c": {
"model": "iPhone 12 Pro"
},
"6_57bca7d7-19f1-46f7-a8ed-744ba2a524c1": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"7_1d82a823-c687-4406-9922-7bcf0a5884ac": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"8_04811a9f-ee00-4739-9b42-d22d85f2aeb3": {
"model": "iPhone 12 Pro"
},
"9_2f7d72de-db99-4797-b146-e6bec58b5e06": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"10_803ff5ce-6a80-4b49-affe-818d13c0cefe": {
"model": "iPhone 12 Pro"
},
"104_06da54c7-4deb-4e34-88fa-d105d509fa18": {
"model": "iPhone 18"
},
"1_5b8bd53b-a706-4aa7-87be-2160eb9140c8": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"2_4c3f4163-7b9b-432f-bb18-8f52ee09a5fe": {
"model": "iPhone 15 Pro, iPhone 15 Pro Max"
},
"3_d213efdb-9c73-4933-bc6f-59cd74e060c9": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"portfolio_models-2": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"5_b43370e7-dd61-4eb6-93c3-fe7c88b9b5c3": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"6_ec10c3e7-de20-4274-b977-3ee03cf4e5a3": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"7_574cf275-280d-471f-a499-96b2fa6eef7c": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"8_3bf956b7-031c-4ca3-81c3-3c3af2b95e39": {
"model": "iPhone 13 Pro, iPhone 13 Pro Max"
},
"portfolio_models": {
"model": "iPhone 14 Pro, iPhone 14 Pro Max"
},
"1_e528fa32-5583-4117-9698-9546db5fd5c4": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"2_ff751dc2-84f1-42ec-bd0a-f5d27528c78f": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"3_8bbdc8a7-dad0-4e77-bf1e-d9c24bd87a98": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"4_9f3a88a2-8e06-4294-bdfb-233413c72f02": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"5_15f2cc29-955c-4a2a-8f13-21d2c69e1306": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"6_b8390fa3-aa9d-406f-bbe7-a232ad2c9dd2": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"8_05353abe-0247-4b31-b9b5-b5d588745962": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"105_768d4f62-df01-492a-8423-eb7701845b32": {
"model": "iPhone 18"
},
"1_f293be0e-5268-48d1-ab92-e75be0f0bd31": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"2_f3a5b9f6-4f42-4849-9dbb-11c8193c76f7": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"3_6eec46b4-4ff7-429b-a353-b14195eea578": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"4_3540d76e-3f1c-4f34-aa61-e3124d679658": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"5_cfb53375-2815-4acc-a4ef-ce454c1351aa": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"6_4f56f47c-9138-4734-ae7d-e0e5ff417fad": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"7_6eed8544-89ae-4b43-b16d-80c0100a22b5": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"8_01504bea-13bd-4dc2-a9bf-03ea111c141e": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"1_8529426a-cb9e-4dfe-b61b-42a48f54d23e": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"2_6a986d20-5bf0-47bb-9dd0-e1871747b85a": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"3_d984b1ec-d778-47c2-aaee-45bc08be7179": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"4_fc2f03da-dd56-401b-9ed8-2b7e35d89a38": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"5_71ad195f-58e4-4486-b427-095ba2a55b11": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"6_3971d503-dee4-46ea-9572-e182f18f573f": {
"model": "iPhone 13, iPhone 14"
},
"7_95ad6485-12ce-4364-a3f6-98a86314960e": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"9_e1deba66-c360-40a2-b5c5-ae9cb4635cf5": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"120_2e5cbd31-cad2-4bf6-bdee-0808634f0454": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"121_39a9d8ee-e20e-4895-bc1e-266b4a7f73ce": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"122": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"123_358c1251-502d-494a-a942-abd123a119a7": {
"model": "iPhone 15 Pro, iPhone 15 Pro Max"
},
"124": {
"model": "iPhone 15 Pro, iPhone 15 Pro Max"
},
"125_0281be14-6d58-4185-b605-2c8b21b733d3": {
"model": "iPhone 15 Pro, iPhone 15 Pro Max"
},
"119_3183848f-f2ce-4031-b74a-42e269321159": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"105_42e4ce38-237d-46d2-ab02-baf5c1bc7b8c": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"103_b45d273a-5837-4443-9d54-9ff2ee495410": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"104_863d44e1-df7c-4e34-a27c-777434b6aae6": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"CopyofCARBON_2": {
"model": "iPhone 18"
},
"CopyofCARBON_4": {
"model": "iPhone 18"
},
"1_f9d3f948-59bb-470c-ac5e-d3c9baccd754": {
"model": "iPhone 16, iPhone 17"
},
"2_ec30dfff-312b-4acf-89a4-7f77dbe05770": {
"model": "iPhone 16, iPhone 17"
},
"3_36c845a7-6a1e-44ae-9175-f735515960d8": {
"model": "iPhone 16, iPhone 17"
},
"5_263ddbe8-752b-46da-80b8-544282e8439f": {
"model": "iPhone 16, iPhone 17"
},
"6_40df03e6-e5df-4748-a1dd-c36837608992": {
"model": "iPhone 16, iPhone 17"
},
"7_4ef97b0d-053f-4718-b55d-1de5336152a0": {
"model": "iPhone 15, iPhone 16, iPhone 17"
},
"8_749819d4-b84e-4fb3-acd5-8c675503e9c7": {
"model": "iPhone 15, iPhone 16, iPhone 17"
},
"115_59107061-b65e-4c1c-985d-98da9ca35f9c": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"116_6a15f2de-4757-42ee-9e25-37de81f1d0fa": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"117_f1ee6ba0-e00b-4054-ab2d-d07d20406335": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"118_51e9bcfc-0392-4c24-bae3-2fbb00de3927": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"106_99fec27a-e5bf-4ed3-b97d-383c0ae47923": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"109": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"110_4a6120d3-01e2-4731-b297-77196459694d": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"111_77c9155a-5b54-4679-b3d3-7bb30182a709": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"112_9597089d-4cad-4dae-80e8-04f40a2ca9a5": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"113_cabbe35b-c58b-400b-8854-f8257adf0a2b": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"114_9677792b-d114-4b6e-baa7-846a0e36b080": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"107_8a351bd6-259b-4ccc-9640-9e3c38249965": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"108_f982d6a0-c05a-43a7-a714-904c5020b189": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"103_e2bb946c-37d3-46af-910e-86abdda47d76": {
"model": "iPhone 18"
},
"1_533ef50e-26f5-4e0b-9984-b518edb795de": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"2_b5aa0bea-e786-43de-b0a3-a6a90a7528dc": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"3_e122fb0d-bf2d-4be6-bafa-a7d8a870c525": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"4_59cc74a3-0d56-47ce-aa52-7c5cbedb128d": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"5_adb44384-67fc-46f4-af75-05f841f5b510": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"6_5bf4b7aa-f07d-4624-9c27-f4573dfcf72c": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"7_b12b4f43-0dba-44d2-abc5-d18276cb5ad8": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"portfolio_models-3": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"9_9b147ca5-1838-44eb-921c-5483e8a7ae31": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"10_20691db1-63ad-4976-99a6-a8c1cddec317": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"11_e7a580f8-ad64-4d06-b82e-e1ad25069263": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"new_CC_16_carousel_pics_and_new_homepage_branding_35": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max"
},
"OXBLOODPDP_4": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max, iPhone 17 Pro, iPhone 17 Pro Max"
},
"148_763f5893-2185-46ff-8814-5285f1dd6ced": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"142_db4dd330-4d7f-4a2e-be34-bc08b5aaf19d": {
"model": "iPhone 17 Air"
},
"146_92924d3f-099e-4f41-89d7-0a1eff766340": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"140_93038ccc-daa3-4ada-9803-e9a16dc85eba": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"153_ac020e4b-4c4f-49e8-ac7a-1d95e1df776a": {
"model": "iPhone 13, iPhone 14"
},
"152_1f069fbb-039a-401b-804c-d182d82f8b2d": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"139_bcc4e5b5-18ba-4479-93bd-604f1d0606e4": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"iPhone131415models_1_066e285f-b697-4c59-9574-c3e8adffe9c7": {
"model": "iPhone 17"
},
"143_3b38ae30-5581-4c23-a7e5-ac92461a7377": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"144_1f1d31f6-8b81-4a32-9812-bb5c129d6011": {
"model": "iPhone 16e, iPhone 17e"
},
"164": {
"model": "iPhone 17 Pro"
},
"167_87f96f39-933e-4fe3-8204-6c95464e0c69": {
"model": "iPhone 17 Pro"
},
"160": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"163": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"166_ea1ff0f6-7424-4f10-a03f-0840555c87df": {
"model": "iPhone 17 Pro"
},
"159": {
"model": "iPhone 17 Air"
},
"168_1702813c-3531-4051-a904-e261839f9aab": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"158": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"165": {
"model": "iPhone 17 Pro Max"
},
"iPhone131415models_2_f2a0dbcc-94e6-4b20-a9b5-48f8237c68f4": {
"model": "iPhone 17"
},
"155": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"156": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"new_CC_16_carousel_pics_and_new_homepage_branding_34": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max"
},
"OXBLOODPDP_3": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max, iPhone 17 Pro, iPhone 17 Pro Max"
},
"128_6522c25f-2e05-40fc-aae3-6292820da402": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"130_f99adee0-4e0d-4fd6-b297-c82d82ebc16e": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"131_75d95032-e613-4bdc-be43-c0205fd0408d": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max"
},
"126_3fc2b9c9-0e9e-42e0-9cef-9d9590001d76": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"iPhone131415models_bdda2dac-c34d-4c92-b0da-f4e9c7dc60e4": {
"model": "iPhone 17"
},
"127": {
"model": "iPhone 17 Air"
},
"new_CC_16_carousel_pics_and_new_homepage_branding_31": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max"
},
"OXBLOODPDP_07bad1ff-a7a3-459c-8053-8e60fce9210c": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max, iPhone 17 Pro, iPhone 17 Pro Max"
},
"iPhone_131415_models_3": {
"model": "iPhone 17"
},
"7_6d75620d-ae3e-402e-a251-e8cd11e75b4f": {
"model": "iPhone 16 Pro Max"
},
"1_05a041aa-4965-44cf-9011-0d3ff52a86b2": {
"model": "iPhone 17 Air"
},
"5_d6052354-d904-4231-9137-52e316600fce": {
"model": "iPhone 17 Air"
},
"6_9c4987fd-b1e1-43e1-958b-024dcba444c3": {
"model": "iPhone 16e, iPhone 17e"
},
"9_f83ff006-f64c-4043-96cb-423bea85ce5f": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro"
},
"new_CC_16_carousel_pics_and_new_homepage_branding_33": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max"
},
"OXBLOODPDP_1_10010ff7-15fb-4db5-a7ec-241b84b0d35f": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max, iPhone 17 Pro, iPhone 17 Pro Max"
},
"iPhone_131415_models": {
"model": "iPhone 17"
},
"12_04a2e5a1-26f2-444d-9e28-233b0f455260": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"transparent_BG_thumbnails_20": {
"model": "iPhone 16e, iPhone 17e"
},
"14_21fa460a-524a-4b2f-b0f6-73c1308c6983": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"1_b06625c2-6f2d-4d97-a770-cd90d5d12bf5": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"7_40910543-a83b-47f9-8320-785f658cbaec": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"10_14173a23-fc45-4503-a81a-f9e61e34b3d5": {
"model": "iPhone 16 Pro"
},
"13_18532570-8fe5-47f6-aae5-b0807779a57b": {
"model": "iPhone 17 Air"
},
"9_4fe503d2-e83d-478b-bc41-c641ceec3a8e": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"182": {
"model": "iPhone 17 Pro Max"
},
"173": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"176": {
"model": "iPhone 17 Pro Max"
},
"174": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"iPhone131415models_3_c388aa6f-6f94-43e0-bfac-31efea73a9f2": {
"model": "iPhone 17"
},
"183": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"181": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"170_833349be-cdf8-4484-99c4-aebe59ce33b0": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"171": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"180": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"179": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"new_CC_16_carousel_pics_and_new_homepage_branding_32": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max"
},
"OXBLOODPDP_2_e8593689-1b84-4e61-a444-bdbeae2b4b62": {
"model": "iPhone 18 Pro, iPhone 18 Pro Max, iPhone 17 Pro, iPhone 17 Pro Max"
},
"24_0b59974c-c836-47de-a70f-cf4dac21c2fa": {
"model": "iPhone 17 Air"
},
"22_313cf693-b6e5-4179-b7b4-ff5bd9fec3fd": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"16_e5c6cd5d-b843-4b7e-80ea-fcce78912327": {
"model": "iPhone 16e, iPhone 17e"
},
"iPhone_131415_models_2": {
"model": "iPhone 17"
},
"10_908921ec-51c5-45c9-b045-997b7e3a52f4": {
"model": "iPhone 13 Pro, iPhone 14 Pro, iPhone 15 Pro, iPhone 16 Pro"
},
"14_1034e58a-5a8f-4d45-aa84-5a3ef2d2fb52": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"19_c578d47f-0d0a-46ab-989b-85a5f8efbde2": {
"model": "iPhone 16 Pro"
},
"25_e5e853ff-cab5-4ccd-8717-e2cb093118a7": {
"model": "iPhone 13, iPhone 14, iPhone 15"
},
"21_60535689-4a11-4eff-9524-23c9021c94a2": {
"model": "iPhone 16 Pro"
},
"23_24b940eb-6637-4992-baaf-e8552bd1d02f": {
"model": "iPhone 16 Pro"
},
"18_83a00652-00d6-49c2-9e79-5aad323c9018": {
"model": "iPhone 16 Pro"
},
"20_35be9272-b497-4524-96bd-51c740a05487": {
"model": "iPhone 16 Pro"
},
"COCOAPDP_2": {
"model": "iPhone 17 Pro, iPhone 17 Pro Max"
},
"COCOAPDP_3": {
"model": "iPhone 16 Pro, iPhone 16 Pro Max, iPhone 15 Pro, iPhone 15 Pro Max"
}
};
  function baseName(src) {
    if (!src) return '';
    var f = src.split('?')[0].split('/').pop() || '';
    return decodeURIComponent(f).replace(/\.[a-z0-9]+$/i, '');
  }
  function norm(v) {
    return String(v || '')
      .replace(/experience/ig, '')
      .replace(/backorder\s*-?\s*/ig, '')
      .replace(/-?\s*ships now/ig, '')
      .replace(/^\s*iphone\s*/i, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }
  function modelSelect() {
    var sels = document.querySelectorAll('.product-information select[name^="options["]');
    for (var i = 0; i < sels.length; i++) {
      if (/iphone|model/i.test(sels[i].name)) return sels[i];
    }
    return null;
  }
  function productModels(sel) {
    var out = {};
    if (!sel) return out;
    for (var i = 0; i < sel.options.length; i++) out[norm(sel.options[i].value)] = true;
    return out;
  }
  function matches(listed, selected, available) {
    for (var i = 0; i < listed.length; i++) {
      var m = norm(listed[i]);
      if (m === selected) return true;
      // "iPhone 18" as written, while the product has no base 18: counts for the whole 18 line.
      if (/^\d+$/.test(m) && !available[m] && selected.indexOf(m + ' ') === 0) return true;
    }
    return false;
  }
  function apply() {
    var sel = modelSelect();
    if (!sel) return;
    var selected = norm(sel.value);
    var available = productModels(sel);
    var root = document.querySelector('.product-information media-gallery') || document;
    root.querySelectorAll('.product-media-container, slideshow-slide').forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      var hit = MAP[baseName(img.getAttribute('src') || img.currentSrc || '')];
      if (!hit) { item.removeAttribute('data-device-hidden'); return; }
      var listed = hit.model.split(/\s*,\s*/);
      var show = matches(listed, selected, available);
      if (show) {
        item.removeAttribute('data-device-hidden');
        if (item.tagName === 'SLIDESHOW-SLIDE') item.removeAttribute('hidden');
      } else {
        item.setAttribute('data-device-hidden', '');
        if (item.tagName === 'SLIDESHOW-SLIDE') item.setAttribute('hidden', '');
      }
    });
    // Thumbnails that point at hidden media
    document.querySelectorAll('.product-information [data-media-id]').forEach(function (el) {
      if (el.closest('.product-media-container, slideshow-slide')) return;
      var id = el.getAttribute('data-media-id');
      var target = root.querySelector('.product-media [data-media-id="' + id + '"], .product-media[data-media-id="' + id + '"]');
      var item = target && target.closest('.product-media-container, slideshow-slide');
      el.style.display = item && item.hasAttribute('data-device-hidden') ? 'none' : '';
    });
  }
  var css = document.createElement('style');
  css.textContent = '.product-information [data-device-hidden]{display:none!important}';
  document.head.appendChild(css);
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
  document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('select[name^="options["]')) schedule(); }, true);
  document.addEventListener('variant:update', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', apply);
})();
